import React from 'react';
import StarIcon from '@mui/icons-material/Star';
export function TestimonialsSection() {
  const testimonials = [{
    initial: 'M',
    name: 'Mariana G.',
    location: 'Córdoba',
    quote: '"Pensé que era difícil y terminé haciendo mi primer cuadro el mismo fin de semana."'
  }, {
    initial: 'L',
    name: 'Luciana P.',
    location: 'Rosario',
    quote: '"Ahora hago regalos personalizados para toda mi familia."'
  }, {
    initial: 'C',
    name: 'Carla M.',
    location: 'Buenos Aires',
    quote: '"Vendí mis primeros trabajos a conocidos antes de terminar el segundo tomo."'
  }];
  return <section className="py-8 md:py-12 px-4 bg-brand-cream" data-id="element-306">
      <div className="max-w-5xl mx-auto" data-id="element-307">
        <div className="text-center mb-5" data-id="element-308">
          <h2 className="font-heading text-2xl md:text-3xl text-brand-dark font-bold mb-1" data-id="element-309">
            💬 CASOS REALES
          </h2>
          <p className="text-brand-pink font-bold text-base" data-id="element-310">
            ❤️ PERSONAS QUE YA COMENZARON
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-311">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border border-brand-pink/10 flex flex-col" data-id="element-312">
              <div className="flex text-yellow-400 mb-2" data-id="element-313">
                <StarIcon fontSize="small" data-id="element-314" />
                <StarIcon fontSize="small" data-id="element-315" />
                <StarIcon fontSize="small" data-id="element-316" />
                <StarIcon fontSize="small" data-id="element-317" />
                <StarIcon fontSize="small" data-id="element-318" />
              </div>
              <p className="text-brand-dark font-medium italic mb-4 flex-grow text-sm md:text-base" data-id="element-319">
                {t.quote}
              </p>
              <div className="flex items-center gap-3" data-id="element-320">
                <div className="w-10 h-10 rounded-full bg-brand-purple text-white flex items-center justify-center font-bold" data-id="element-321">
                  {t.initial}
                </div>
                <div data-id="element-322">
                  <p className="font-bold text-brand-dark text-sm" data-id="element-323">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-324">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}